document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('CountrySelectorForm');
  const input = document.getElementById('CountrySelectorCode');
  const buttons = document.querySelectorAll('.js-country-btn');

  const mobileSelect = document.getElementById('MobileCountrySelect');

  if (form && input) {
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        input.value = btn.dataset.isoCode;
        form.submit();
      });
    });

    if (mobileSelect) {
      mobileSelect.addEventListener('change', (e) => {
        const val = e.target.value;
        if (val.startsWith('URL:')) {
          window.location.href = val.replace('URL:', '');
        } else if (val.startsWith('ISO:')) {
          input.value = val.replace('ISO:', '');
          form.submit();
        }
      });
    }
  }
});
